import { isConfiguratorProduct, type ProductData } from "~/domains/product/types/ProductData";
import {
  CARRIAGE_CONFIGURATOR_PRODUCT_CODE,
  INCH_SHAFT_CONFIGURATOR_PRODUCT_CODE,
  KLLT_UNIT_CONFIGURATOR_PRODUCT_CODE,
  KUEM_UNIT_CONFIGURATOR_PRODUCT_CODE,
  KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE,
  METRIC_SHAFT_CONFIGURATOR_PRODUCT_CODE,
  RAIL_CONFIGURATOR_PRODUCT_CODE,
  TKDM_RAIL_CONFIGURATOR_PRODUCT_CODE,
  TKLT_RAIL_CONFIGURATOR_PRODUCT_CODE,
  UNIT_CONFIGURATOR_PRODUCT_CODE,
} from "~/domains/configurator/constants";

/**
 * Please keep values synchronised with java file
 * com.hybris.schaeff.facades.productconfig.ConfiguratorType
 */
export enum ConfiguratorType {
  System = 1,
  Carriage = 2,
  Rail = 3,
  MetricShaft = 4,
  InchShaft = 5,
}

export enum ConfiguratorFamily {
  Classic = "CLASSIC",
  KUEM = "KUEM",
  KLLT = "KLLT",
}

export type ShaftConfiguratorType = ConfiguratorType.InchShaft | ConfiguratorType.MetricShaft;

const configuratorTypeMap: Record<string, ConfiguratorType> = {
  [RAIL_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.Rail,
  [TKDM_RAIL_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.Rail,
  [TKLT_RAIL_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.Rail,
  [CARRIAGE_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.Carriage,
  [KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.Carriage,
  [UNIT_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.System,
  [KLLT_UNIT_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.System,
  [KUEM_UNIT_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.System,
  [METRIC_SHAFT_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.MetricShaft,
  [INCH_SHAFT_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorType.InchShaft,
};
const configuratoFamilyMap: Record<string, ConfiguratorFamily> = {
  [TKDM_RAIL_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorFamily.KUEM,
  [TKLT_RAIL_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorFamily.KLLT,
  [KWLT_CARRIAGE_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorFamily.KLLT,
  [KLLT_UNIT_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorFamily.KLLT,
  [KUEM_UNIT_CONFIGURATOR_PRODUCT_CODE]: ConfiguratorFamily.KUEM,
};

export function getConfiguratorType(product: ProductData): ConfiguratorType | null {
  if (!isConfiguratorProduct(product)) {
    return null;
  }

  return getConfiguratorTypeFromProductCode(product.code);
}

export function getConfiguratorTypeFromProductCode(productCode: string): ConfiguratorType | null {
  return configuratorTypeMap[productCode] ?? null;
}

export function getConfiguratorFamilyFromProductCode(productCode: string): ConfiguratorFamily | null {
  if (getConfiguratorTypeFromProductCode(productCode)) {
    return configuratoFamilyMap[productCode] ?? ConfiguratorFamily.Classic;
  }
  return null;
}
